/**
 * Service worker registration.
 *
 * `onUpdate` fires when a new build has been downloaded but is waiting behind
 * the tab still running the old one. Home-screen apps are rarely closed, so
 * without a nudge users can sit on a stale bundle for days.
 */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/)
);

export function register({ onUpdate, onSuccess } = {}) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  // Service workers are origin-scoped; a different PUBLIC_URL origin can't be
  // controlled by a worker served from here.
  const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;

          installing.onstatechange = () => {
            if (installing.state !== 'installed') return;

            if (navigator.serviceWorker.controller) {
              // Old content is still being served by the active worker.
              if (onUpdate) onUpdate(registration);
            } else if (onSuccess) {
              onSuccess(registration);
            }
          };
        };
      })
      .catch((error) => {
        if (isLocalhost) console.error('SW registration failed:', error);
      });

    // Reload once the new worker takes control, so the page and the assets it
    // asks for come from the same build.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
